import { Navigate, useParams } from 'react-router-dom';

export function Sessions() {
  const { serverId } = useParams<{ serverId: string }>();
  return <Navigate to={`/servers/${serverId}`} replace />;
}
